import { FC, KeyboardEvent, MouseEvent } from 'react';
import { Button } from '@common/components';
import { CategoriesPicker, CategoriesPickerProps } from './CategoriesPicker';
import { DatesPicker, DatesPickerProps } from './DatesPicker';
import { ButtonClassFiltersColumn, ClassFiltersWrapper, FiltersWrapper } from './Filters.styles';
import { GuestsPicker, GuestsPickerProps } from './GuestsPicker';
import { PromoRateCodeInput, PromoRateCodeInputProps } from './PromoRateCodeInput';
import { SearchInput, SearchInputProps } from './SearchInput';

type FiltersProps = {
  onFiltersApply: (event: KeyboardEvent<HTMLElement> | MouseEvent<HTMLElement>) => void;
  submitLabel: string;
  isPrimary?: boolean;
  editingGuestDetails?: boolean;
  toggleEditGuestDetails?: (isEditing: boolean) => void;
  rateCode?: string;
  roomCode?: string;
  isHomepage?: boolean;
  isFetching?: boolean;
} & CategoriesPickerProps &
  Omit<DatesPickerProps, 'journeyParams' | 'propertyId' | 'fetchAvailability'> &
  GuestsPickerProps &
  SearchInputProps &
  PromoRateCodeInputProps;

export const Filters: FC<FiltersProps> = ({
  numberOfAdults,
  rooms,
  categories,
  childAgesProps,
  fromDate,
  numberOfChildren,
  isInsideModal,
  label,
  onCloseGuestPicker,
  onCategoryChange,
  onDateChange,
  onFiltersApply,
  selectedCategory,
  toDate,
  showDatesPicker,
  showGuestsPicker,
  showCategoriesPicker,
  showSearchInput,
  onGuestCountChange,
  onRoomCountChange,
  disableCategorySelect,
  submitLabel,
  searchInputLabel,
  searchPhrase,
  onSearchPhraseChange,
  isSingle,
  isPrimary,
  acceptPromoRateCode,
  onApplyPromoRateCode,
  promoRateCode,
  availability,
  toggleEditGuestDetails,
  editingGuestDetails,
  rateCode,
  roomCode,
  isHomepage,
  isFetching,
}) => (
  <FiltersWrapper>
    <ClassFiltersWrapper>
      {!editingGuestDetails && (
        <DatesPicker
          isSingle={isSingle}
          showDatesPicker={showDatesPicker}
          toDate={toDate}
          fromDate={fromDate}
          onDateChange={onDateChange}
          availability={availability}
          rateCode={rateCode}
          roomCode={roomCode}
          isHomepage={isHomepage}
        />
      )}
      <GuestsPicker
        numberOfAdults={numberOfAdults}
        numberOfChildren={numberOfChildren}
        showGuestsPicker={showGuestsPicker}
        onGuestCountChange={onGuestCountChange}
        isSingle={isSingle}
        childAgesProps={childAgesProps}
        onCloseGuestPicker={onCloseGuestPicker}
        toggleEditGuestDetails={toggleEditGuestDetails}
        editingGuestDetails={!!editingGuestDetails}
        rooms={rooms}
        onRoomCountChange={onRoomCountChange}
      />
      <PromoRateCodeInput
        acceptPromoRateCode={acceptPromoRateCode}
        onApplyPromoRateCode={onApplyPromoRateCode}
        onFiltersApply={onFiltersApply}
        promoRateCode={promoRateCode}
      />
      <CategoriesPicker
        isInsideModal={isInsideModal}
        categories={categories}
        label={label}
        onCategoryChange={onCategoryChange}
        selectedCategory={selectedCategory}
        showCategoriesPicker={showCategoriesPicker}
        disableCategorySelect={disableCategorySelect}
      />
      <SearchInput
        showSearchInput={showSearchInput}
        searchInputLabel={searchInputLabel}
        searchPhrase={searchPhrase}
        onSearchPhraseChange={onSearchPhraseChange}
      />
      {!editingGuestDetails && (
        <ButtonClassFiltersColumn>
          <Button isPrimary={isPrimary} onClick={onFiltersApply} isInline isLoading={isFetching}>
            {submitLabel}
          </Button>
        </ButtonClassFiltersColumn>
      )}
    </ClassFiltersWrapper>
  </FiltersWrapper>
);
